module.exports = {
	array: require('./src/array'),
	common: require('./src/common'),
	currency: require('./src/currency'),
	date: require('./src/date'),
	filesize: require('./src/filesize'),
	number: require('./src/number'),
	object: require('./src/object'),
	string: require('./src/string'),
	time: require('./src/time'),
	url: require('./src/url'),
};
